/**
 * @title rx.js: Feature level module
 * @description The module used for the 'rx'
 * feature which encapsulates 'rx homepage','rx feature pages'
 * 'product details', etc.
 * @dependency rxsignin and bunch of others
 */
define(['rxrefillprescription','rxprescriptionstatus','rxnewprescription', 'rxtransferprescription', 'rxpatientprofile', 'rxprescriptionhelper','rxaddresshelper','rxsignin','rxsearch','rxdrugdetails','checkout_helper', 'address', 'addressSelectionDialog', 'addressForm', 'pharmacyRefillPrescription', 'rxcontactus', 'rxfamilyaccount', 'timeoutModal'], 
function(rxRefillPrescription, rxPrescriptionStatus, rxNewPrescription, rxTransferPrescription, rxPatientProfile, rxPrescriptionHelper, rxAddressHelper, rxSignin, rxSearch, rxDrugDetails, checkout_helper, address, addressSelectionDialog, addressForm, pharmacyRefillPrescription, rxContactUs, rxFamilyAccount, timeoutModal) {
	function init() {
		// Case where user is timed out from pharmacy page and clicks back in browser tab without logging in. This reloads the page so that the user relands on the logon page rather than the auth pharmacy page.
		if (window.performance && window.performance.getEntriesByType("navigation")[0].type === 'back_forward' && !$.cookie('hashedUserId')) {
			window.location.reload(true)
		}

		address.bindEvents();
		rxSignin.init();
		rxSearch.init();
		rxContactUs.init();
		
		let page = $('[data-page]').data('page') || '';
		if(page.indexOf('NewPrescription,PrescriptionSearch,FIXED') >= 0
				|| page.indexOf('TransferPrescription,PrescriptionSearch,FIXED') >= 0
				|| page.indexOf('HomeDeliveryHome,DrugDirectory,FIXED') >= 0){
		rxDrugDetails.init();
		
		}


		if (page.indexOf('HDRefillPrescription') >= 0) {
			let addressSettings = undefined;
			
			if (page.indexOf('HDRefillPrescriptionConfirmation') >= 0) {
				addressSettings = {
					updateURL : '/AjaxPrescriptionManageAddressCmd?mode=UPDATE&fromPage=' + rxCheckoutPageName,
					addURL : '/AjaxPrescriptionManageAddressCmd?mode=ADD&fromPage=' + rxCheckoutPageName,
					setDefaultURL : '/AjaxPrescriptionManageAddressCmd?mode=SET_DEFAULT&fromPage=' + rxCheckoutPageName
				}
				
				rxPrescriptionHelper.init();
			}

			rxRefillPrescription.init(addressSettings);
			
		} else if (page.indexOf('NewPrescription') >= 0) {
			let addressSettings = undefined;
			if (page.indexOf('ConfirmPrescriptionRequest') >= 0) {
				addressSettings = {
					updateURL : '/AjaxPrescriptionManageAddressCmd?mode=UPDATE&fromPage=' + rxCheckoutPageName,
					addURL : '/AjaxPrescriptionManageAddressCmd?mode=ADD&fromPage=' + rxCheckoutPageName,
					setDefaultURL : '/AjaxPrescriptionManageAddressCmd?mode=SET_DEFAULT&fromPage=' + rxCheckoutPageName
				}
				
				rxPrescriptionHelper.init();
			}

			rxNewPrescription.init(addressSettings);
			
		} else if (page.indexOf('TransferPrescription') >= 0) {

			let addressSettings = undefined;

			if (page.indexOf('ConfirmTransferRequest') >= 0) {
				addressSettings = {
					updateURL : '/AjaxPrescriptionManageAddressCmd?mode=UPDATE&fromPage=' + rxCheckoutPageName,
					addURL : '/AjaxPrescriptionManageAddressCmd?mode=ADD&fromPage=' + rxCheckoutPageName,
					setDefaultURL : '/AjaxPrescriptionManageAddressCmd?mode=SET_DEFAULT&fromPage=' + rxCheckoutPageName
				}
				
				rxPrescriptionHelper.init();
			}

			rxTransferPrescription.init(addressSettings);

		} else if (page.indexOf('PatientInformation') >= 0) {
				rxPatientProfile.init();
		} else if (page.indexOf('ManageFamilyAccount') >= 0) {
			rxFamilyAccount.init();
		} else if (page.indexOf('wh-rx-status') >= 0) {
			pharmacyRefillPrescription.init();
		} else if (page.indexOf('HDPrescriptionStatus') >= 0) {
			rxPrescriptionStatus.init();
		}
		
		// Begin: A temporary fix to identify the header skip element for legacy pharmacy pages
		// 			which do not have the right headerskip element. Needs to be removed during re-design
		var skipContentElementID = $('a[id="skip-content"]').attr('href');
		if(!$(skipContentElementID).length) {
			$('a[id="skip-content"]').attr('href','#main_content_wrapper');
		}
		
		$('.control--radio input[type="radio"]').on("focusin", function(){
			$(this).next().addClass('ada-outline');
		})

		$('.control--radio input[type="radio"]').on("blur", function(){
			$(this).next().removeClass('ada-outline');
		})
		
		
		// This handles the case when the pharmacy patient has accept their
		// prescription details privacy notice and is back on the Pharmacy Homepage
		// A keyword has been placed in the URL and is only present when the user is coming from
		// the PharmacySavePrescriptionDetailsAcceptanceCmd.
		
		var param = COSTCO.util.getParameterByName("keyword")
		if (param == 'prescaccepted') {
			COSTCO.dialog.createExtDialogBox({
				title: "Success",
				body:  "Your preferences have been saved successfully.",
				primary: messages.JS_DIALOG_CLOSE,
				primary_event : ()=> {
			          COSTCO.dialog.close();
				},
			})
		}
		
		$('a.prescription-acceptance').click(function() {
			var link = this.href;
			COSTCO.dialog.createExtDialogBox({
				title: "Warning",
				body:  "Your changes have not been saved. Are you sure you want to leave this page?",
				primary: messages.JS_DIALOG_STAY_ON_PAGE,
				primary_event : ()=> {
			          COSTCO.dialog.close();
				},
				secondary: messages.JS_DIALOG_LEAVE_PAGE,
				secondary_event : ()=> {
			          COSTCO.dialog.close();
			          window.location = link;
				}
				
			})
			return false;
		})

		// Adds aria-current for ADA Compliance on "Left Navbar" link for Pharmacy.
		$("div.leftnav-element.active").find("a").attr("aria-current", "page");

		$("ol.progress-meter").find("li.active").attr("aria-current", "step");
		
		//Aria-expanded true/false switch for drug details when Drug Details info displays only
		rxDrugDetails.rxDrugDetailAriaExpandSwitch();
		
		//Aria-expanded true/false switch for all expandable rx tabs
		rxPatientProfile.rxAriaExpandSwitch();
		
		timeoutModal.init(); 
	}

	if (typeof window.COSTCO == 'undefined') {
		window.COSTCO = new Object();
	}
	
	if (typeof window.COSTCO.Global == 'undefined') {
		document.addEventListener("CostcoGlobalLoaded", init, false);
	} else {
		init();
	}

});



// WEBPACK FOOTER //
// ./js/rx/rx.js